import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, ShoppingCart, Package } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

export default function MobilePODetailPage() {
  const { poId } = useParams();
  const navigate = useNavigate();
  const [po, setPo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/warehouse/purchase-orders/${poId}`).then(r => setPo(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, [poId]);

  if (loading) return <div className="mobile-page"><div className="mobile-loading"><div className="mobile-spinner" /></div></div>;
  if (!po) return <div className="mobile-page"><button className="mobile-back-btn" onClick={() => navigate(-1)}><ArrowLeft size={18} /> Back</button><div className="mobile-empty-state"><p>PO not found</p></div></div>;

  const lineItems = po.line_items || [];

  return (
    <div className="mobile-page">
      <button className="mobile-back-btn" onClick={() => navigate('/mobile/purchase-orders')}><ArrowLeft size={18} /> Purchase Orders</button>
      <div className="mobile-detail-section" style={{ textAlign: 'center', paddingTop: 20, paddingBottom: 20 }}>
        <div style={{ width: 48, height: 48, borderRadius: 12, background: '#007aff', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 10px', color: 'white' }}><ShoppingCart size={24} /></div>
        <div style={{ fontSize: 20, fontWeight: 700, color: '#1c1c1e' }}>{po.po_number}</div>
        <span className={`mobile-status-badge ${po.status === 'received' ? 'in_production' : 'scheduled'}`} style={{ marginTop: 8 }}>{po.status || 'open'}</span>
      </div>
      <div className="mobile-detail-section">
        <div className="mobile-detail-section-title">Details</div>
        {po.vendor_name && <div className="mobile-detail-row"><span className="mobile-detail-label">Vendor</span><span className="mobile-detail-value">{po.vendor_name}</span></div>}
        {po.supplier && <div className="mobile-detail-row"><span className="mobile-detail-label">Supplier</span><span className="mobile-detail-value">{po.supplier}</span></div>}
        {po.order_date && <div className="mobile-detail-row"><span className="mobile-detail-label">Order Date</span><span className="mobile-detail-value">{po.order_date}</span></div>}
        {po.expected_date && <div className="mobile-detail-row"><span className="mobile-detail-label">Expected</span><span className="mobile-detail-value">{po.expected_date}</span></div>}
        <div className="mobile-detail-row"><span className="mobile-detail-label">Items</span><span className="mobile-detail-value">{lineItems.length}</span></div>
      </div>
      {lineItems.length > 0 && (
        <div className="mobile-detail-section">
          <div className="mobile-detail-section-title">Line Items ({lineItems.length})</div>
          {lineItems.map((li, i) => (
            <div key={i} className="mobile-detail-row">
              <span className="mobile-detail-label"><Package size={12} style={{ display: 'inline', verticalAlign: -1, marginRight: 4 }} />{li.item_name || `Item ${i+1}`}</span>
              <span className="mobile-detail-value">{li.quantity_ordered || li.quantity || 0} {li.unit || ''}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
